import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCooling = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="M11.016 4c2.562 0 4.656 1.937 4.968 4.437.063.313-.218.594-.53.563l-3.845-.375c.25.719.407 1.531.407 2.406 0 2.563-1.938 4.656-4.438 4.969-.312.063-.594-.219-.562-.531l.375-3.844c-.72.25-1.532.375-2.407.375C2.422 12 .297 10.094.016 7.594c-.063-.313.218-.625.53-.563l3.813.375C4.11 6.687 3.984 5.875 3.984 5c0-2.563 1.938-4.656 4.438-5 .312-.063.594.219.562.531L8.61 4.375C9.33 4.125 10.141 4 11.016 4ZM7.984 9c.563 0 .97-.469.97-1 0-.563-.47-1-.97-1a.98.98 0 0 0-.968 1c0 .531.406 1 .968 1Z"
    />
  </svg>
));
export default SvgIconCooling;
